// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14lsx","content":"styles_content__G6hmw","tableWrap":"styles_tableWrap__1OhcD"};